import { useState, useEffect } from "react";
import firebaseUtil from "../data/FirebaseUtil";
import app from "./firebaseStart";
import config from "../data/application.properties";
const firestore = app.firestore();
// Function to check if DGAM license is enabled using an API call
const checkDGAMLicense = async () => {
  try {
    // const licenseresult = await firebaseUtil.getIsDGAMLicensed();  
    const dgamLicense = await(
      await firestore.collection("tenants").doc(config.TENANT_ID).collection("Configuration").doc("AppSettings")
        .get()
    ).data();
    const enabled = dgamLicense && dgamLicense.EnableDGAMFeature;
    return enabled;
  } catch (error) {
    console.error("Error checking license:", error);
    return false;
  }
};

// Custom hook to check the DGAM license
export const useDGAMLicenseCheck = () => {
  const [isDGAMLicensed, setIsDGAMLicensed] = useState(false);
  const [loadingLicense, setLoadingLicense] = useState(true);

  useEffect(() => {
    const fetchLicenseStatus = async () => {
      setLoadingLicense(true);
      const enabled = await checkDGAMLicense();
      setIsDGAMLicensed(enabled);
      setLoadingLicense(false);
    };

    fetchLicenseStatus();
  }, []);

  return { isDGAMLicensed, loadingLicense };
};
